import React from 'react';
import { ToggleButton, ToggleButtonGroup, SxProps, Theme } from '@mui/material';
import { GridView, FormatListBulleted } from '@mui/icons-material';
import { neutral, primary } from '_lex/_foundations/phxColors';

export type ViewMode = 'grid' | 'list';

export type LexViewToggleProps = {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
  sx?: SxProps<Theme>;
};

const buttonSx = (isSelected: boolean) => ({
  px: 4,
  py: 2,
  border: 'none',
  borderRadius: 0,
  backgroundColor: isSelected ? primary[50] : 'transparent',
  '& svg': {
    fontSize: 18,
    color: isSelected ? primary[600] : neutral[500],
  },
  '&.Mui-selected': {
    backgroundColor: primary[50],
  },
  '&.Mui-selected:hover': {
    backgroundColor: primary[50],
  },
  '&:hover': {
    backgroundColor: isSelected ? primary[50] : 'transparent',
  },
});

const LexViewToggle: React.FC<LexViewToggleProps> = ({ value, onChange, sx }) => {
  const handleChange = (_: React.MouseEvent, newValue: ViewMode | null) => {
    if (newValue !== null) onChange(newValue);
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      sx={{
        border: `1px solid ${neutral[200]}`,
        borderRadius: 2,
        overflow: 'hidden',
        '& .MuiToggleButton-root': { border: 'none' },
        '& .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
          borderRight: `1px solid ${neutral[200]}`,
        },
        ...sx,
      }}
    >
      <ToggleButton value="grid" sx={buttonSx(value === 'grid')}>
        <GridView />
      </ToggleButton>
      <ToggleButton value="list" sx={buttonSx(value === 'list')}>
        <FormatListBulleted />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default LexViewToggle;
